import { render, staticRenderFns } from "./DDCreateTemplate.vue?vue&type=template&id=71460837&"
import script from "./DDCreateTemplate.vue?vue&type=script&lang=js&"
export * from "./DDCreateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DDCreateTemplate.vue?vue&type=style&index=0&id=71460837&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71460837')) {
      api.createRecord('71460837', component.options)
    } else {
      api.reload('71460837', component.options)
    }
    module.hot.accept("./DDCreateTemplate.vue?vue&type=template&id=71460837&", function () {
      api.rerender('71460837', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/DDCreateTemplate.vue"
export default component.exports